<template>
  <div id="app" :class="pageClass + setClass">
    <template v-if="loading">
      <Loader fullPage></Loader>
    </template>
    <template v-else>
      <navbar v-if="logged && permisos!==false && !IsFormPage"
              @newComercial="newComercial"
              @toggleGoogle="toggleGoogle"
              @toggleKmz="toggleKmz"
              ref="navbar"
              @draw="drawFlag = !drawFlag"
              @potential="showPotentialFlag = !showPotentialFlag"
              :permisos="permisos">
      </navbar>
      <template v-slot:advise v-if="drawFlag">
        <drawarea ref='drawAreaPotential' v-if="showPotentialFlag" @accept="showPotentialResults"
                  @cancel="hidePotential" @add="addPolygon" @select="selectArea"></drawarea>
        <drawarea ref='drawAreaLotes' :view='drawAreaLotesView' v-if="drawAreaLotes" @accept="acceptLotes"
                  @cancel="cancelLotes" @add="addPolygon" @select="selectArea"></drawarea>
      </template>
      <Tools v-if="logged && !IsFormPage"
             @showInfo="infoFlag=!infoFlag"
             @showStreet="streetFlag=!streetFlag"
             @close="closeInfo"
             @draw="drawDistance = !drawDistance"
             ref="tools">
      </Tools>
      <StreetView v-if="logged" ref="streetview" @close="closeInfo"></StreetView>
      <div id="content" class="main">
        <router-view
          :infoFlag="infoFlag"
          :streetFlag="streetFlag"
          :user_id="user_id">
        </router-view>
        <PopUp @calderaSaved="calderaSaved" @comercialSaved="comercialSaved" v-if="showPopUp && logged"
               @changeLocation="changeLocation" @getLocation="getLocation" @setLocation="setLocation"
               :clickEvent="clickEvent"
               :ComercialTypes="ComercialTypes" :permisos="permisos" @clickFeature="clickFeature" @hide="hidePopUp"
               @selectedArea="addSelectedArea" :selectarea="isSelectArea"></PopUp>
        <GoogleTooltip @setLocation="setLocation" :comercial="comercioGoogle" v-if="showComercioGoogle && logged"
                       :permisos="permisos" @hide="showComercioGoogle = false"></GoogleTooltip>
        <div v-if="newComercialFlag && logged" class="mapButtons">
          <b-button @click="cancelMapButtons">Cancelar</b-button>
          <b-button @click="saveComercialPos">Guardar</b-button>
        </div>
        <div v-if="logged" class="popstyle" v-bind:style="{display:parsedLocalizado}">
          <b-modal class="fixedModal" ref="myModal" size="lg" id="modal1" title="Comercial" centered :hide-footer="true"
                   @hidden="cancelMapButtons">
            <Details ref="details" :feature="details" :permisos="permisos" @close="closeNewComercial"></Details>
          </b-modal>
        </div>
      </div>
      <div v-if="!logged || IsFormPage" class="push"></div>
      <VueFooter v-if="!logged || IsFormPage"></VueFooter>

      <!-- Alerts generales -->
      <SuccessAlert></SuccessAlert>
      <ErrorAlert></ErrorAlert>
      <WarningAlert></WarningAlert>

      <!-- Progress bar -->
      <nprogress-container></nprogress-container>
    </template>
  </div>
</template>

<style>
.mapButtons {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 9;
}

.popstyle {
  position: absolute;
  top: 0;
  left: 0;
  background: #0000007a;
  width: 100%;
  height: 100%;
  z-index: 9;
}

.absoluteButton {
  position: absolute;
  right: 0%;
  bottom: 0%;
  z-index: 9;
}

.square-principal {
  width: 2px;
  height: 2px;
  background-color: yellow;
  opacity: 0.5;
}

.circle-suministrada {
  height: 2px;
  width: 2px;
  background-color: red;
  border-radius: 50%;
  opacity: 0.5;
}

.table-responsive {
  padding-bottom: 4.5rem;
}

/* .leaflet-overlay-pane{
  z-index: 199;
} */

.leaflet-control-zoom-display {
  right: 4rem;
  top: 8rem;
  position: fixed;
}

/* .leaflet-control-layers {
  right: 3rem;
} */
</style>

<script>

import Loader from '@/components/Layout/Loader.vue';
import VueFooter from '@/components/Layout/Footer.vue';
import VueBreadcrumbs from '@/components/Layout/Breadcrumbs.vue';
import navbar from '@/components/Layout/Navbar.vue';
import PopUp from '@/components/Modules/Map/PopUp.vue';
import Vue from 'vue';
import Tools from '@/components/Modules/Tools.vue';
import Details from '@/components/Modules/Map/Details.vue';
import StreetView from '@/components/Modules/StreetView.vue';
import GoogleTooltip from '@/components/Modules/GoogleTooltip.vue';
import Area from '@/components/Modules/Map/Area.vue';
import SuccessAlert from './components/Modules/Alerts/SuccessAlert';
import ErrorAlert from './components/Modules/Alerts/ErrorAlert';
import NprogressContainer from './components/Modules/NprogressContainer.vue';
import WarningAlert from './components/Modules/Alerts/WarningAlert';

export default {
  name: 'App',
  components: {
    NprogressContainer,
    SuccessAlert,
    ErrorAlert,
    WarningAlert,
    VueFooter,
    VueBreadcrumbs,
    navbar,
    Loader,
    PopUp,
    Tools,
    Details,
    GoogleTooltip,
    StreetView,
    'drawarea': Area
  },
  computed: {
    parsedLocalizado: function () {
      if (this.showModal) {
        return 'block';
      } else {
        return 'none';
      }
    },
    pageClass () {
      return ('app-' + this.$route.name.toLowerCase());
    },
    logged: function () {
      // Check if kernel_token cookie is in the client
      return document.cookie.indexOf('kernel_token') > -1;
    },
    IsFormPage: function () {
      return this.$route.name === 'Form';
    }
  },
  methods: {
    selectArea () {
      this.isSelectArea = true;
      this.map.drawer.disable();
    },
    addSelectedArea (row) {
      const layer = self.L.geoJSON(row, {'color': '#37393C'});
      this.map.drawerLayers.push(layer);
      layer.addTo(this.map.map);
      this.deleteArea(layer);
      this.isSelectArea = false;
    },
    toggleKmz (f) {
      console.log(f);
      if (f) {
        this.$children[3].addKmzLayer();
      } else {
        this.$children[3].removeKmzLayer();
      }
    },
    toggleGoogle: function (f) {
      this.comerciosGoogle = f;

      this.control.remove();
      if (this.comerciosGoogle) {
        this.map.map.removeLayer(this.baseLayers[0]);
        this.map.map.removeLayer(this.baseLayers[1]);
        this.control = self.L.control.layers({
          'Vista estándar': this.baseLayers_google[0],
          'Vista satélite': this.baseLayers_google[1]
        }, {}, {autoZIndex: true});
        this.map.map.addLayer(this.baseLayers_google[0]);
      } else {
        this.map.map.removeLayer(this.baseLayers_google[0]);
        this.map.map.removeLayer(this.baseLayers_google[1]);
        this.control = self.L.control.layers({
          'Vista estándar': this.baseLayers[0],
          'Vista satélite': this.baseLayers[1]
        }, {}, {autoZIndex: true});
        this.map.map.addLayer(this.baseLayers[0]);
      }
      this.control.addTo(this.map.map);
    },
    setSearchMarker: function (location, name) {
      const marker = self.L.marker(location);
      const popup = self.L.popup({}).setContent(name);

      popup.on('remove', function () {
        marker.remove();
      });

      marker.addTo(this.map.map).bindPopup(popup).openPopup();
    },
    setSearchPolygon: function (pol, name) {
      const polLayer = self.L.geoJSON(pol);
      const popup = self.L.popup({}).setContent(name);

      popup.on('remove', function () {
        polLayer.remove();
      });

      polLayer.addTo(this.map.map).bindPopup(popup).openPopup();
    },
    calderaSaved: function () {
      if (this.$refs.navbar.$refs.lotespopup) {
        // if (this.$refs.navbar.$refs.lotespopup.gestionandoLote) {
        this.$refs.navbar.$refs.lotespopup.calderaChanged();
        // }
      }
    },
    comercialSaved: function () {
      if (this.$refs.navbar.$refs.lotespopup) {
        // if (this.$refs.navbar.$refs.lotespopup.gestionandoLote) {
        this.$refs.navbar.$refs.lotespopup.comercialChanged();
        // }
      }
    },
    closeNewComercial: function () {
      this.details = {
        'type': 'Feature',
        'id': 'comercial.',
        'geometry': {
          'type': 'Point',
          'coordinates': [null, null]
        },
        'geometry_name': 'geom',
        'properties': {
          'id': null,
          'id_categoria_gn_comercial': {
            'id': null,
            'categoria_gn_comercial': '',
            'index': null,
            'puede_crear': true
          },
          'id_gas_finca': {
            'id': null,
            'gas': '',
            'index': null
          },
          'id_status_gestion_comercial': {
            'id': null,
            'status': '',
            'index': null
          },
          'id_clase_establecimiento_gn_comercial': {
            'id': null,
            'tipo': '',
            'index': null
          },
          'id_tipo_establecimiento_gn_comercial': {
            'id': null,
            'id_categoria_gn_comercial': {
              'id': null,
              'categoria_gn_comercial': '',
              'index': null,
              'puede_crear': true
            },
            'tipo': '',
            'potencial': true
          },
          'id_precision_coordenada': {
            'id': 1,
            'tipo_precision': ''
          },
          'codigo': null,
          'nombre': '',
          'provincia': '',
          'municipio': '',
          'poblacion': null,
          'direccion': null,
          'high_press_main_in_service_dis': null,
          'in_service_mains_distance': null,
          'fecha_cambio_status': null,
          'fecha_presupuesto_entregado': null,
          'motivo_rechazo': null,
          'motivo_no_potencial': null,
          'observaciones': null,
          'geom': null,
          'resto_direccion': null,
          'direccion_no_estructurada': '',
          'visible': true,
          'codigo_via': null,
          'tipo_via': null,
          'nombre_via': null,
          'codigo_postal': '',
          'google_place_id': null,
          'empresa_instaladora': null,
          'datos_contacto': '',
          'codigo_cnae': null,
          'id_amp_origen': null,
          'metadatos': '',
          'longitud_original': null,
          'latitud_original': null,
          'epsg_original': null,
          'create_user': '',
          'create_date': null,
          'update_user': '',
          'update_date': '',
          'cliente': false,
          'numero': null,
          'anexo': null,
          'codigo_provincia_zeus': '',
          'codigo_municipio_zeus': '',
          'codigo_poblacion_zeus': null,
          'intocable': '',
          'not_abandoned_mains_distance': null,
          'high_pressure_mains_distance': null,
          'nombre_propietario': null,
          'email_propietario': null,
          'telefono_propietario': null
        },
        'tipo_name': '',
        'desc': ''
      };
      this.$refs.myModal.hide();
    },
    newComercial: function () {
      this.modLayer = self.L.marker(this.map.map.getCenter(), {draggable: true});
      this.modLayer.addTo(this.map.map);
      this.newComercialFlag = true;
    },
    saveComercialPos: function () {
      this.newComercialFlag = false;
      const larlng = this.modLayer.getLatLng();
      this.details = {
        'type': 'Feature',
        'id': 'comercial.',
        'geometry': {
          'type': 'Point',
          'coordinates': [null, null]
        },
        'geometry_name': 'geom',
        'properties': {
          'id': null,
          'id_categoria_gn_comercial': {
            'id': null,
            'categoria_gn_comercial': '',
            'index': null,
            'puede_crear': true
          },
          'id_gas_finca': {
            'id': null,
            'gas': '',
            'index': null
          },
          'id_status_gestion_comercial': {
            'id': null,
            'status': '',
            'index': null
          },
          'id_clase_establecimiento_gn_comercial': {
            'id': null,
            'tipo': '',
            'index': null
          },
          'id_tipo_establecimiento_gn_comercial': {
            'id': null,
            'id_categoria_gn_comercial': {
              'id': null,
              'categoria_gn_comercial': '',
              'index': null,
              'puede_crear': true
            },
            'tipo': '',
            'potencial': true
          },
          'id_precision_coordenada': {
            'id': 1,
            'tipo_precision': ''
          },
          'codigo': null,
          'nombre': '',
          'provincia': '',
          'municipio': '',
          'poblacion': null,
          'direccion': null,
          'high_press_main_in_service_dis': null,
          'in_service_mains_distance': null,
          'fecha_cambio_status': null,
          'fecha_presupuesto_entregado': null,
          'motivo_rechazo': null,
          'motivo_no_potencial': null,
          'observaciones': null,
          'geom': JSON.stringify(this.modLayer.toGeoJSON().geometry),
          'resto_direccion': null,
          'direccion_no_estructurada': '',
          'visible': true,
          'codigo_via': null,
          'tipo_via': null,
          'nombre_via': null,
          'codigo_postal': '',
          'google_place_id': null,
          'empresa_instaladora': null,
          'datos_contacto': '',
          'codigo_cnae': null,
          'id_amp_origen': null,
          'metadatos': '',
          'longitud_original': larlng.lng,
          'latitud_original': larlng.lat,
          'epsg_original': null,
          'create_user': '',
          'create_date': null,
          'update_user': '',
          'update_date': '',
          'cliente': false,
          'numero': null,
          'anexo': null,
          'codigo_provincia_zeus': '',
          'codigo_municipio_zeus': '',
          'codigo_poblacion_zeus': null,
          'intocable': '',
          'not_abandoned_mains_distance': null,
          'high_pressure_mains_distance': null,
          'nombre_propietario': null,
          'email_propietario': null,
          'telefono_propietario': null
        },
        'tipo_name': '',
        'desc': ''
      };
      this.showModal = true;
      this.$refs.myModal.show();
    },
    cancelMapButtons: function () {
      if (this.modLayer) {
        this.map.map.removeLayer(this.modLayer);
      }
      this.newComercialFlag = false;
      this.showModal = false;
    },
    changeLocation: function (feature) {
      // this.map.map.removeLayer(this.selectedLayer)
      this.modLayer = self.L.marker([feature.geometry.coordinates[1], feature.geometry.coordinates[0]], {draggable: true});

      const popup = self.L.popup({
        closeOnClick: false,
        autoClose: false,
        closeButton: false,
        autoPan: false
      }).setContent('Posicione la finca dentro de la manzana');

      const th = this;
      this.modLayer.on('movestart', function (e) {
        th.modLayer.openPopup();
      });

      this.modLayer.addTo(this.map.map).bindPopup(popup).openPopup();
      this.map.map.setView(this.modLayer.getLatLng());
    },
    getLocation: function (modification = null) {
      const popup = self.L.popup({
        closeOnClick: false,
        autoClose: false,
        closeButton: false,
        autoPan: false
      }).setContent('Ubicación sugerida');

      const popup2 = self.L.popup({
        closeOnClick: false,
        autoClose: false,
        closeButton: false,
        autoPan: false
      }).setContent('Ubicación original');

      const th = this;
      try {
        this.modLayer.on('click', function (e) {
          th.modLayer.openPopup();
        });
      } catch (err) {
        this.modLayer = self.L.marker([modification.latitud, modification.longitud]);
      }

      this.modLayer.addTo(this.map.map).bindPopup(popup).openPopup();
      this.map.map.setView(this.modLayer.getLatLng(), 20);

      this.map.map.removeLayer(this.selectedLayer);
      this.selectedLayer.addTo(this.map.map).bindPopup(popup2).openPopup();
    },
    setLocation: function () {
      this.map.map.closePopup();
      if (this.selectedLayer) {
        this.map.map.fitBounds(this.selectedLayer.getBounds(), {maxZoom: 20});
      }
    },
    SetNewLocation: function () {
      this.selectedLayer = this.modLayer;
    },
    hidePopUp: function () {
      this.showPopUp = false;
      if (this.selectedLayer) {
        this.map.map.removeLayer(this.selectedLayer);
        this.removeCalderasLayers();
      }
    },
    removeCalderasLayers () {
      for (let i in this.otherCaldera) {
        const layer = this.otherCaldera[i];
        this.map.map.removeLayer(layer);
      }
      this.otherCaldera = [];
    },
    clickFeature: async function (feature) {
      this.otherCaldera = [];

      // Feature properties
      const featureType = feature.id && feature.id.split('.')[0];
      const featureId = feature.id && feature.id.split('.')[1];

      if (featureType === 'caldera') {
        if (feature.properties.caldera_centralizada === 'SUMINISTRADA') {
          this.selectedLayer = self.L.geoJSON(feature.geometry, {
            pointToLayer: function (fea, latlng) {
              return self.L.circleMarker(latlng, {
                radius: 20,
                fillColor: 'red',
                color: 'red',
                weight: 5,
                opacity: 0.5,
                fillOpacity: 0.5
              });
            }
          });
          this.$http.get(`caldera/${featureId}/principal/`).then(response => {
            this.calderaPrincipal = response.body.caldera;
            const caldera = self.L.geoJSON(JSON.parse(response.body.geom), {
              pointToLayer: function (fea, latlng) {
                return self.L.circleMarker(latlng, {
                  radius: 20,
                  fillColor: 'yellow',
                  color: 'yellow',
                  weight: 5,
                  opacity: 0.5,
                  fillOpacity: 0.5
                });
              }
            });

            this.otherCaldera.push(caldera);
            caldera.addTo(this.map.map);
            this.selectedLayer.addTo(this.map.map);
          });
        } else if (feature.properties.caldera_centralizada === 'PRINCIPAL') {
          this.calderaPrincipal = null;
          this.selectedLayer = self.L.geoJSON(feature.geometry, {
            pointToLayer: function (fea, latlng) {
              return self.L.circleMarker(latlng, {
                radius: 20,
                fillColor: 'yellow',
                color: 'yellow',
                weight: 5,
                opacity: 0.5,
                fillOpacity: 0.5
              });
            }
          });

          this.$http.get(`caldera/${featureId}/suministrada/`).then(response => {
            for (let i in response.body.geom) {
              const geojson = response.body.geom[i];
              const caldera = self.L.geoJSON(JSON.parse(geojson), {
                pointToLayer: function (fea, latlng) {
                  return self.L.circleMarker(latlng, {
                    radius: 20,
                    fillColor: 'red',
                    color: 'red',
                    weight: 5,
                    opacity: 0.5,
                    fillOpacity: 0.5
                  });
                }
              });
              this.otherCaldera.push(caldera);
            }

            for (let i in this.otherCaldera) {
              const layer = this.otherCaldera[i];
              layer.addTo(this.map.map);
            }
            this.selectedLayer.addTo(this.map.map);
          });
        }
      } else {
        try {
          this.selectedLayer = self.L.geoJSON(feature.geometry, {
            style: function (f) {
              return {color: 'red'};
            }
          });

          if (feature.geometry.type !== 'Point') {
            this.selectedLayer.addTo(this.map.map);
          } else {
            // var popup = self.L.popup({
            //   closeOnClick: false,
            //   autoClose: false,
            //   closeButton: false,
            //   autoPan: false
            // }).setContent('Ubicación original')

            this.selectedLayer.addTo(this.map.map); // .bindPopup(popup).openPopup()
          }
        } catch (err) {
        }
      }
    },
    hasPermision: function (group, p) {
      if (group.name === 'Territorio') {
        return (this.permisos['TERRITORIO GN'][p] || this.permisos['TERRITORIO NO GN'][p]);
      } else {
        if (group.rol) {
          return this.permisos[group.rol][p];
        } else {
          return false;
        }
      }
    },
    updateUIAfterThemeChanged: function () {
      let s = '';
      if (localStorage.getItem('size') === 'Big') {
        s = s + ' app-font-big';
      }
      if (localStorage.getItem('contrast') === 'HighContrast') {
        s = s + ' app-color-contrast';
      }
      this.setClass = s;
      return s;
    },
    setMap: function (m, baseLayers, baseLayers2, control, polygonDrawer) {
      this.map.map = m;

      self.L.control.zoom({position: 'topright'}).addTo(this.map.map);

      this.map.pane = this.map.map.createPane('mypane');
      this.map.map.getPane('mypane').style.zIndex = 650;

      this.baseLayers = baseLayers;
      this.baseLayers_google = baseLayers2;
      this.control = control;
      this.setDrawer(polygonDrawer); // set drawer for the map. the map has been initialized already, no need to wait.

      this.$refs.navbar.getComercialTerritorioLayers(); // Init Comercial and Territorio layers without label count (we wait for the filtering/visibility)

      Promise.all([
        this.$http.get('filtros_usuarios/', {params: {usuario: this.user_id}}),
        this.$http.get('filtros_caldera/', {params: {usuario: this.user_id}})
      ]).then(response => {
        this.$refs.navbar.getVisibility(() => {
          this.initLayers(() => {
            let filtroscaldera = response[1].data.results[0];
            let filtroscomerciales = response[0].data.results[0];

            this.applyFilter(filtroscomerciales, filtroscaldera);
          }); // Init Red, Residencial and Territorio layers. Get label count as well (they will always be the same - no filtering on these layers)
        });

        // Apply the filters for Comercial and Territorio
        // Apply the visibility saved
      });

      // Init layers with filters comercial and caldera.
    },
    // setLayers () {
    //   this.$refs.navbar.getVisibility()
    //   // this.initLayers()
    // },
    setDrawer (d) {
      this.map.drawer = d;
    },
    getLayersJSON () {
      const geojsonarray = [];
      for (let i in this.map.drawerLayers) {
        let layer = this.map.drawerLayers[i];
        try {
          geojsonarray.push(JSON.stringify(layer.toGeoJSON().features.map(i => i.geometry)[0]));
        } catch (err) {
          geojsonarray.push(JSON.stringify(layer.toGeoJSON().geometry));
        }
      }
      return geojsonarray;
    },
    showPotentialResults: function () {
      this.drawFlag = false;
      this.isSelectArea = false;
      this.showPotentialFlag = false;
      this.$refs.navbar.showPotentialResults();
    },
    hidePotential () {
      this.isSelectArea = false;
      this.drawFlag = false;
      this.showPotentialFlag = false;
      this.$refs.navbar.hidePotential();
      this.map.drawer.disable();
    },
    addPolygon () {
      this.isSelectArea = false;
      this.map.drawer.enable();
    },
    setDistanceDrawer (d) {
      this.map.distanceDrawer = d;
    },
    disableLayer: function (l) {
      if (l.layer && l.layer.constructor === Array) {
        for (let index = 0; index < l.layer.length; index++) {
          const layer = l.layer[index];
          this.map.map.removeLayer(layer);
        }
      } else if (l.layer) {
        this.map.map.removeLayer(l.layer);
        // if (l.name === 'Catastro opaco') {
        //   for (let index = 0; index < this.baseLayers.length; index++) {
        //     const baseLayer = this.baseLayers[index]
        //     baseLayer.setOpacity(1)
        //   }
        // }
      }
    },
    getCountLayer: function (layer) {
      if (!layer.catastro) {
        this.$http.post('count/', {params: {type: layer.layer_name}}).then(result => {
          layer.count = result.data.count;
        });
      }

      //   var params = {}
      //   var params2 = {}
      //   const l = layer

      //   if (layer.layer_name === 'acometidas') {
      //     layer.count = 0

      //     params = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: 'geovisor:acometida',
      //       version: '1.1.0'
      //     }
      //     params2 = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: 'geovisor:acometida_enterrada',
      //       version: '1.1.0',
      //       CQL_FILTER: "icono LIKE 'ACOMETIDA_ENTERRADA%'"
      //     }

      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = l.count + parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params2, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = l.count + parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //   } else if (layer.layer_name === 'geovisor:grp_residencial_unifamiliar') {
      //     layer.count = 0

      //     params = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: 'geovisor:multifincas_unifamiliar',
      //       version: '1.1.0'
      //     }
      //     params2 = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: 'geovisor:residencial_unifamiliar',
      //       version: '1.1.0'
      //     }

      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = l.count + parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params2, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = l.count + parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //   } else if (layer.layer_name === 'geovisor:grp_residencial_bifamiliar') {
      //     layer.count = 0

      //     params = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: 'geovisor:multifincas_bifamiliar',
      //       version: '1.1.0'
      //     }
      //     params2 = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: 'geovisor:residencial_bifamiliar',
      //       version: '1.1.0'
      //     }

      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = l.count + parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params2, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = l.count + parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //   } else if (layer.layer_name === 'geovisor:grp_residencial_plurifamiliar') {
      //     layer.count = 0

      //     params = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: 'geovisor:multifincas_plurifamiliar',
      //       version: '1.1.0'
      //     }
      //     params2 = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: 'geovisor:residencial_plurifamiliar',
      //       version: '1.1.0'
      //     }

      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = l.count + parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params2, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = l.count + parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //   } else {
      //     params = {
      //       request: 'GetFeature',
      //       resultType: 'hits',
      //       typeName: layer.layer_name,
      //       version: '1.1.0'
      //     }

      //     self.$.ajax({
      //       url: url + self.L.Util.getParamString(params, url, true),
      //       success: function (data, status, xhr) {
      //         l.count = parseInt(data.all[0].attributes.numberOfFeatures.value)
      //       },
      //       error: function (xhr, status, error) {
      //         console.log(error)
      //       }
      //     })
      //   }
      // }
    },
    enableLayer: function (l) {
      if (l.layer_name === 'geovisor:comercial' && Object.keys(l.filter).indexOf('id') === -1) {
        if (this.hasPermision({rol: 'COMERCIAL'}, 'A')) {
          return 0;
        }
      }
      if (l.layer_name === 'geovisor:caldera' && Object.keys(l.filter).indexOf('id') === -1) {
        if (this.hasPermision({rol: 'CALDERA CENTRALIZADA'}, 'A')) {
          return 0;
        }
      }
      if (l.layer && l.layer.constructor === Array) {
        for (let index = 0; index < l.layer.length; index++) {
          const layer = l.layer[index];
          this.map.map.addLayer(layer);
        }
      } else if (l.layer) {
        if (l.zindex && !l.catastro) {
          l.layer.setZIndex(l.zindex);
          this.map.map.addLayer(l.layer);
        } else {
          this.map.map.addLayer(l.layer);
          // if (l.name === 'Catastro opaco') {
          //   for (let index = 0; index < this.baseLayers.length; index++) {
          //     const baseLayer = this.baseLayers[index]
          //     baseLayer.setOpacity(0)
          //   }
          // }
        }
      }
    },
    fitBounds: function (bbox) {
      this.map.map.fitBounds(bbox);
    },
    setView: function (bbox) {
      this.map.map.setView(bbox, 20);
    },
    setBounds: function (geojson) {
      const layer = self.L.geoJSON(geojson);
      this.map.map.fitBounds(layer.getBounds());
    },
    closeInfo: function () {
      this.map.map.removeLayer(this.infoMarker);
    },
    showInfo: function (e) {
      if (this.infoMarker) {
        this.closeInfo();
      }
      this.infoMarker = self.L.marker([e.latlng.lat, e.latlng.lng]);
      this.infoMarker.addTo(this.map.map);
      if (this.infoFlag) {
        this.$refs.tools.getInfo(e);
      }
      if (this.streetFlag) {
        this.$refs.streetview.getInfo(e);
      }
    },
    searchGooglePlace: function (e) {
      this.$http.get('NearbyPlaces/', {
        params: {
          location: e.latlng.lat + ',' + e.latlng.lng
        }
      }).then(result => {
        if (result.data.results.length > 0) {
          this.comercioGoogle = result.data.results[0].result;
          // this.showComercioGoogle = true
          const popup = self.L.popup()
            .setLatLng(this.comercioGoogle.geometry.location)
            .setContent(
              '<p><strong>' + this.comercioGoogle.name +
              '</strong><br>' + this.comercioGoogle.adr_address +
              '</p> <button id="createComercio" class="btn btn-primary">Crear comercio</button>'
            )
            .openOn(this.map.map);

          const th = this;
          // console.log(popup)
          self.$('#createComercio').bind('click',
            function (e) {
              th.createGoogleComercial();
            });
          return popup;
        } else {
          this.showPopUp = true;
        }
      });
    },
    createGoogleComercial: function () {
      const latlng = this.comercioGoogle.geometry.location;
      let postalCode = '';
      for (let index = 0; index < this.comercioGoogle.address_components.length; index++) {
        const element = this.comercioGoogle.address_components[index];
        if (element.types[0] === 'postal_code') {
          postalCode = element.long_name;
        }
      }

      this.details = {
        'type': 'Feature',
        'id': 'comercial.',
        'geometry': {
          'type': 'Point',
          'coordinates': [null, null]
        },
        'geometry_name': 'geom',
        'properties': {
          'id': null,
          'id_categoria_gn_comercial': {
            'id': null,
            'categoria_gn_comercial': '',
            'index': null,
            'puede_crear': true
          },
          'id_gas_finca': {
            'id': null,
            'gas': '',
            'index': null
          },
          'id_status_gestion_comercial': {
            'id': null,
            'status': '',
            'index': null
          },
          'id_clase_establecimiento_gn_comercial': {
            'id': null,
            'tipo': '',
            'index': null
          },
          'id_tipo_establecimiento_gn_comercial': {
            'id': null,
            'id_categoria_gn_comercial': {
              'id': null,
              'categoria_gn_comercial': '',
              'index': null,
              'puede_crear': true
            },
            'tipo': '',
            'potencial': true
          },
          'id_precision_coordenada': {
            'id': 1,
            'tipo_precision': ''
          },
          'codigo': null,
          'nombre': this.comercioGoogle.name,
          'provincia': '',
          'municipio': '',
          'poblacion': null,
          'direccion': null,
          'high_press_main_in_service_dis': null,
          'in_service_mains_distance': null,
          'fecha_cambio_status': null,
          'fecha_presupuesto_entregado': null,
          'motivo_rechazo': null,
          'motivo_no_potencial': null,
          'observaciones': 'Comercio Google',
          'geom': JSON.stringify(this.comercioGoogle.geometry),
          'resto_direccion': null,
          'direccion_no_estructurada': this.comercioGoogle.formatted_address,
          'visible': true,
          'codigo_via': null,
          'tipo_via': null,
          'nombre_via': null,
          'codigo_postal': postalCode,
          'google_place_id': null,
          'empresa_instaladora': null,
          'datos_contacto': '',
          'codigo_cnae': null,
          'id_amp_origen': null,
          'metadatos': '',
          'longitud_original': latlng.lng,
          'latitud_original': latlng.lat,
          'epsg_original': null,
          'create_user': '',
          'create_date': null,
          'update_user': '',
          'update_date': '',
          'cliente': false,
          'numero': null,
          'anexo': null,
          'codigo_provincia_zeus': '',
          'codigo_municipio_zeus': '',
          'codigo_poblacion_zeus': null,
          'intocable': '',
          'not_abandoned_mains_distance': null,
          'high_pressure_mains_distance': null,
          'nombre_propietario': null,
          'email_propietario': null,
          'telefono_propietario': this.comercioGoogle.formatted_phone_number
        },
        'tipo_name': '',
        'desc': ''
      };
      this.showModal = true;
      this.$refs.myModal.show();
    },
    setInteraction: function () {
      const th = this;
      this.map.map.on('click', function (e) {
        if (!th.drawFlag && !th.drawDistance) {
          if (th.infoFlag || th.streetFlag) {
            th.showInfo(e);
          } else {
            th.clickEvent = e;
            if (th.comerciosGoogle) {
              th.searchGooglePlace(e);
            }
            th.showPopUp = true;
          }
        } else if (th.drawFlag && th.isSelectArea) {
          th.clickEvent = e;
          th.showPopUp = true;
        }
      });

      this.map.map.on('draw:canceled', function (e) {
        if (th.showPotentialFlag) {
          th.$refs.drawAreaPotential.clicked = null;
        } else if (th.drawAreaLotes) {
          th.$refs.drawAreaLotes.clicked = null;
        }
      });

      this.map.map.on('draw:created', function (e) {
        // var type = e.layerType

        if (th.showPotentialFlag) {
          th.$refs.drawAreaPotential.clicked = null;
        } else if (th.drawAreaLotes) {
          th.$refs.drawAreaLotes.clicked = null;
        }

        const layer = e.layer;
        if (!th.drawDistance) {
          th.map.drawerLayers.push(layer);
          layer.addTo(th.map.map);
          th.deleteArea(layer);
        }
      });

      this.map.map.on('draw:drawstop', function (e) {
        if (th.drawDistance) {
          th.$refs.tools.presseddist = false;
          th.drawDistance = false;
        }
      });
    },
    deleteArea (layer) {
      const th = this;
      layer.on('click', function (e) {
        const r = confirm('¿Quieres borrar esta área?');

        if (r) {
          th.map.drawerLayers.splice(th.map.drawerLayers.findIndex(element => {
            element._leaflet_id === this._leaflet_id;
          }), 1);
          th.map.map.removeLayer(this);
        }
      });
    },
    setDrawerLayersFromLote (layers, viewOnly) {
      const th = this;
      for (let i in layers) {
        const layer = self.L.GeoJSON.geometryToLayer(JSON.parse(layers[i]));
        layer.addTo(this.map.map);
        if (!viewOnly) {
          layer.on('click', function (e) {
            const r = confirm('¿Quieres borrar esta área?');

            if (r) {
              th.map.drawerLayers.splice(th.map.drawerLayers.findIndex(element => {
                element._leaflet_id === this._leaflet_id;
              }), 1);
              th.map.map.removeLayer(this);
            }
          });
        }
        this.map.map.fitBounds(layer.getBounds());
        this.map.drawerLayers.push(layer);
      }
    },
    createLayer: function (layer) {
      const redLayers = ['geovisor:red', 'geovisor:red_inyeccion', 'acometidas', 'geovisor:plantas_glp', 'geovisor:planta_gnl', 'geovisor:gasinera', 'geovisor:mun_red_desplazada'];
      if (redLayers.indexOf(layer.layer_name) > -1) {
        if (this.permisos['RED']['A']) {
          if (layer.layer_name === 'acometidas') {
            layer.layer_name = layer.layer_name + '_A_group';
          } else {
            layer.styles = 'A_group_' + layer.layer_name;
          }
        }
      }

      let l = null;
      let url = process.env.URL_WMS;

      let trans = true;
      let tiled = true;
      if (layer.tiled !== undefined) {
        tiled = layer.tiled;
      }
      // console.log(layer)

      if (layer.catastro) {
        url = 'https://ovc.catastro.meh.es/Cartografia/WMS/ServidorWMS.aspx?';
        trans = layer.transparent;
        tiled = false;
      }
      if (tiled) {
        // DISABLE CACHE
        // if (layer.layer_name !== 'geovisor:comercial' && layer.layer_name !== 'geovisor:caldera' && layer.layer_name !== 'acometidas') { url = url.replace('/wms?', '/gwc/service/wms?') }
        let CqlFilter = [];
        if (layer.filter) {
          CqlFilter = this.getArrayCql(layer);
        }
        if (CqlFilter.length) {
          l = self.L.tileLayer.wms(url, {
            pane: this.map.pane,
            styles: layer.styles,
            layers: layer.layer_name,
            SRS: 'EPSG:4326',
            transparent: trans,
            format: 'image/png',
            info_format: 'application/json',
            CQL_FILTER: CqlFilter.join(' AND '),
            maxZoom: 22
          });
        } else {
          l = self.L.tileLayer.wms(url, {
            pane: this.map.pane,
            styles: layer.styles,
            layers: layer.layer_name,
            SRS: 'EPSG:4326',
            transparent: trans,
            format: 'image/png',
            info_format: 'application/json',
            maxZoom: 22
          });
        }
      } else {
        let cqlFilter2 = [];
        if (layer.filter) {
          cqlFilter2 = this.getArrayCql(layer);
        }
        if (cqlFilter2.length) {
          l = self.L.WMS.overlay(url, {
            pane: this.map.pane,
            layers: layer.layer_name,
            styles: layer.styles,
            transparent: trans,
            CQL_FILTER: cqlFilter2.join(' AND '),
            format: 'image/png',
            maxZoom: 22
          });
        } else {
          l = self.L.WMS.overlay(url, {
            pane: this.map.pane,
            layers: layer.layer_name,
            styles: layer.styles,
            transparent: trans,
            format: 'image/png',
            maxZoom: 22
          });
        }
      }
      l.setZIndex = function (z) {
        return 0;
      };
      return l;
    },
    createLayerGeojson (layerName, layer) {
      const params = {
        request: 'GetFeature',
        service: 'WFS',
        srs: self.L.CRS.EPSG4326.code,
        outputFormat: 'json',
        exceptions: 'application/json',
        version: '1.1.0',
        typeName: layerName
      };
      // var th = this
      const url = process.env.URL_WMS;
      self.$.ajax({
        url: url + self.L.Util.getParamString(params, url, true),
        success: function (data, status, xhr) {
          // layer.on('mouseover', function () {
          //   this.bindPopup('Cuidado ojito')
          //   this.openPopup()
          // })
          layer.addData(data);
        },
        error: function (xhr, status, error) {
          console.error('Ha surgido un error cargando la capa de municipio red desplazada');
          layer = null;
        }
      });
    },
    initLayers: function (cb) {
      // TODO check permissions V before create because it could be unnecessary
      for (let index = 0; index < this.map.layers.length; index++) {
        const group = this.map.layers[index];

        let layer = null;
        if (group.layers && this.hasPermision(group, 'V')) {
          if (group.name === 'Territorio') {
            let territoriolayers = [];
            if (this.permisos['TERRITORIO GN']['V']) {
              territoriolayers = group.layers.filter(l => l.territoriogn);
            }

            if (this.permisos['TERRITORIO NO GN']['V']) {
              territoriolayers = territoriolayers.concat(group.layers.filter(l => !l.territoriogn));
            }

            for (let index2 = 0; index2 < territoriolayers.length; index2++) {
              layer = territoriolayers[index2];

              this.getCountLayer(layer);

              layer.layer = this.createLayer(layer);

              if (layer.active/* && group.active */) {
                this.enableLayer(layer);
              }
            }
            // for (let index2 = 0; index2 < group.layers.length; index2++) {
            //   layer = group.layers[index2]
            //   this.getCountLayer(layer)

            //   if (layer.name === 'Zonas NEDGIA') {
            //     layer.layer = this.createLayer(layer)

            //     if (layer.active && group.active) {
            //       this.enableLayer(layer)
            //     }
            //   }
            // }
          } else {
            for (let index2 = 0; index2 < group.layers.length; index2++) {
              layer = group.layers[index2];

              this.getCountLayer(layer);
              if (layer.geojson) {
                this.createLayerGeojson(layer.layer_name, layer.layer);
              } else {
                layer.layer = this.createLayer(layer);
              }

              if (layer.active) {
                this.enableLayer(layer);
              }
            }
          }
        }
      }
      this.setInteraction();
      cb();
    },
    getPermisos: function () {
      Promise.all([
        // FIXME: la primera petición podria no hacer falta si nos guardamos los datos del usuario al hacer login
        this.$http.get(`tokens/${Vue.cookie.get('kernel_token')}/`, {params: {not_paginated: true}}),
        this.$http.get('roles_map/user-permissions-list/', {params: {not_paginated: true}})
      ]).then(response => {
        this.user_id = response[0].data.user.id;
        this.permisos = response[1].data;
        this.loading = false;
      });
    },
    getArrayCql (layer) {
      const CqlFilter = [];
      for (let index = 0; index < Object.keys(layer.filter).length; index++) {
        const key = Object.keys(layer.filter)[index];
        const value = layer.filter[key];
        if (value.constructor === Array) {
          let type = layer.filter[key]['type'] ? layer.filter[key]['type'] : ' IN';
          CqlFilter.push(key + type + ' (' + value.toString() + ')');
        } else if (layer.filter[key]['end']) {
          CqlFilter.push(value.value);
        } else if (layer.filter[key]['type']) {
          let type = layer.filter[key]['type'];
          CqlFilter.push(key + type + value.value);
        } else {
          CqlFilter.push(key + '=' + value);
        }
      }
      return CqlFilter;
    },
    applyFilter (filtroscomerciales, filtroscaldera) {
      if (filtroscomerciales) {
        this.$refs.navbar.setInitialComercialFilter(filtroscomerciales);
        // this.$refs.navbar.applyFilter('comercial', false)
      }
      if (filtroscaldera) {
        this.$refs.navbar.setInitialCalderaFilter(filtroscaldera);
        // this.$refs.navbar.applyFilter('caldera', false)
      }
    },
    /**
     * Draw Area LotesPopUp
     */
    acceptLotes () {
      this.drawFlag = false;
      this.drawAreaLotes = false;
      this.$refs.navbar.acceptlotesPopUp();
    },
    cancelLotes () {
      this.isSelectArea = false;
      this.drawFlag = false;
      this.drawAreaLotes = false;
      this.$refs.navbar.cancellotesPopUp();
    }
  },
  data: function () {
    return {
      isSelectArea: false,
      calderaPrincipal: null,
      comercioGoogle: null,
      showComercioGoogle: false,
      baseLayers_google: [],
      control: null,
      comerciosGoogle: false,
      user_id: null,
      baseLayers: [],
      modLayer: null,
      showModal: false,
      newComercialFlag: false,
      selectedLayer: null,
      otherCaldera: null,
      showPopUp: false,
      permisos: false,
      loading: true,
      infoFlag: false,
      streetFlag: false,
      drawFlag: false,
      drawDistance: false,
      setClass: this.updateUIAfterThemeChanged(),
      ComercialTypes: [],
      infoMarker: null,
      showPotentialFlag: false,
      drawAreaLotes: false,
      drawAreaLotesView: false,
      map: {
        map: null,
        drawer: null,
        distanceDrawer: null,
        drawerLayers: [],
        drawerLayerEdit: null,
        layers: [
          {
            name: 'Red',
            active: false,
            rol: 'RED',
            indeterminate: false,
            show: false,
            actions: [
              {name: 'Info', icon: 'fa fa-info', function: 'openInfo', p: 'V'}
            ],
            layers: [
              {
                name: 'Red',
                styles: '',
                layer_name: 'geovisor:red',
                active: false,
                zindex: 201,
                icon_name: 'red_subtramo',
                count: 0
              },
              {
                name: 'Red inyección biogás',
                styles: '',
                layer_name: 'geovisor:red_inyeccion',
                active: false,
                zindex: 202,
                icon_name: 'red_subtramo',
                count: 0
              },
              {
                name: 'Acometida',
                styles: '',
                layer_name: 'acometidas',
                active: false,
                zindex: 201,
                icon_name: 'red_acometida',
                count: 0
              },
              {
                name: 'Plantas GLP',
                styles: '',
                layer_name: 'geovisor:plantas_glp',
                active: false,
                zindex: 203,
                icon_name: 'red_glp',
                count: 0
              },
              {
                name: 'Plantas GNL',
                styles: '',
                layer_name: 'geovisor:plantas_gnl',
                active: false,
                zindex: 203,
                icon_name: 'red_gnl',
                count: 0
              },
              {
                name: 'Gasineras',
                styles: '',
                layer_name: 'geovisor:gasinera',
                active: false,
                zindex: 203,
                icon_name: 'red_gasinera',
                count: 0
              },
              {
                name: 'Municipios red desplazada',
                styles: '',
                layer_name: 'geovisor:mun_red_desplazada',
                active: false,
                zindex: 204,
                count: 0,
                icon_name: 'red_desplazada',
                geojson: false
                // layer: self.L.geoJSON(null, {
                //   'style': function () { return { 'color': '#ffa500', 'weight': 2 } }
                //   // 'onEachFeature': function (feature, layer) {
                //   // TODO make advise to measure
                //   //   layer.bindPopup('Cuidado ojito')
                //   //   // layer.on('mouseover', function () { layer.openPopup() })
                //   //   // layer.on('mouseout', function () { layer.closePopup() })
                //   // }
                // })
              }
            ]
          },
          {
            name: 'Residencial',
            active: false, // To skip this in production
            indeterminate: false,
            rol: 'RESIDENCIAL',
            show: false,
            actions: [
              {name: 'Info', icon: 'fa fa-info', function: 'openInfo', p: 'V'}
            ],
            layers: [
              {
                name: 'Fincas Unifamiliares',
                styles: '',
                layer_name: 'geovisor:grp_residencial_unifamiliar',
                active: false,
                zindex: 102,
                icon_name: 'residencial_unifamiliar',
                count: 0
              },
              {
                name: 'Fincas Bifamiliares',
                styles: '',
                layer_name: 'geovisor:grp_residencial_bifamiliar',
                active: false,
                zindex: 102,
                icon_name: 'residencial_bifamiliar',
                count: 0
              },
              {
                name: 'Fincas Plurifamiliares',
                styles: '',
                layer_name: 'geovisor:grp_residencial_plurifamiliar',
                active: false,
                zindex: 102,
                icon_name: 'residencial_plurifamiliar',
                count: 0
              }
            ]
          },
          {
            name: 'Caldera',
            rol: 'CALDERA CENTRALIZADA'
          },
          {
            name: 'Comercial',
            rol: 'COMERCIAL'
          },
          {
            name: 'Territorio',
            active: false,
            indeterminate: false,
            show: false,
            actions: [
              {name: 'Info', icon: 'fa fa-info', function: 'openInfo', p: 'V'}
            ],
            layers: [
              {
                name: 'Zonas NEDGIA',
                styles: '',
                layer_name: 'geovisor:zona_gn',
                active: false,
                tiled: true,
                zindex: 100,
                icon_name: 'territorio_zonasgn',
                territoriogn: false,
                count: 0
              },
              {
                name: 'Provincias',
                styles: '',
                layer_name: 'geovisor:provincia',
                active: false,
                tiled: true,
                zindex: 100,
                icon_name: 'territorio_provincias',
                territoriogn: false,
                count: 0
              },
              {
                name: 'Municipios',
                styles: '',
                layer_name: 'geovisor:municipio',
                active: false,
                tiled: true,
                zindex: 100,
                icon_name: 'territorio_municipios',
                territoriogn: false,
                count: 0
              },
              {
                name: 'Códigos Postales',
                styles: '',
                layer_name: 'geovisor:codigo_postal',
                tiled: false,
                active: false,
                icon_name: 'territorio_codigospostales',
                territoriogn: false,
                count: 0
              },
              {
                name: 'Zonas NO NEDGIA',
                styles: '',
                layer_name: 'geovisor:territorio_gn',
                active: false,
                tiled: true,
                zindex: 101,
                icon_name: 'territorio_areasnognd',
                territoriogn: true,
                count: 0
              },
              {
                name: 'Secciones Censales',
                styles: '',
                layer_name: 'geovisor:seccion_censal',
                active: false,
                tiled: false,
                icon_name: 'territorio_secciones',
                territoriogn: false,
                count: 0
              },
              {
                name: 'Núcleos Urbanos',
                styles: '',
                layer_name: 'geovisor:nucleo_urbano',
                active: false,
                icon_name: 'territorio_nucleos',
                territoriogn: false,
                count: 0
              },
              {
                name: 'Exención Derechos de Alta',
                styles: '',
                layer_name: 'geovisor:territorio_gn_derechos_alta',
                active: false,
                tiled: true,
                zindex: 101,
                icon_name: 'territorio_exencioncanon_borde',
                territoriogn: true,
                count: 0
              },
              {
                name: 'Exención Canon IRC',
                styles: '',
                layer_name: 'geovisor:territorio_gn_canon_irc',
                active: false,
                tiled: true,
                zindex: 101,
                icon_name: 'territorio_exencionalta_borde',
                territoriogn: true,
                count: 0
              },
              {
                name: 'Catastro opaco',
                styles: '',
                layer_name: 'CATASTRO',
                active: false,
                catastro: true,
                transparent: false,
                zindex: 99,
                icon_name: 'catastro',
                count: 0
              },
              {
                name: 'Catastro transparente',
                styles: '',
                layer_name: 'CATASTRO',
                active: false,
                catastro: true,
                transparent: true,
                zindex: 99,
                icon_name: 'catastro',
                count: 0
              },
              {
                name: 'Parcelas Catastro',
                styles: '',
                layer_name: 'PARCELA',
                active: false,
                catastro: true,
                transparent: true,
                zindex: 99,
                icon_name: 'catastro',
                count: 0
              },
              {
                name: 'Manzanas Catastro',
                styles: '',
                layer_name: 'MASA',
                active: false,
                catastro: true,
                transparent: true,
                zindex: 99,
                icon_name: 'catastro',
                count: 0
              },
              {
                name: 'Textos Catastro',
                styles: '',
                layer_name: 'TEXTOS',
                active: false,
                catastro: true,
                transparent: true,
                zindex: 99,
                icon_name: 'catastro',
                count: 0
              }
            ]
          }
        ]
      },
      details: {
        'type': 'Feature',
        'id': 'comercial.',
        'geometry': {
          'type': 'Point',
          'coordinates': [null, null]
        },
        'geometry_name': 'geom',
        'properties': {
          'id': null,
          'id_categoria_gn_comercial': {
            'id': null,
            'categoria_gn_comercial': '',
            'index': null,
            'puede_crear': true
          },
          'id_gas_finca': {
            'id': null,
            'gas': '',
            'index': null
          },
          'id_status_gestion_comercial': {
            'id': null,
            'status': '',
            'index': null
          },
          'id_clase_establecimiento_gn_comercial': {
            'id': null,
            'tipo': '',
            'index': null
          },
          'id_tipo_establecimiento_gn_comercial': {
            'id': null,
            'id_categoria_gn_comercial': {
              'id': null,
              'categoria_gn_comercial': '',
              'index': null,
              'puede_crear': true
            },
            'tipo': '',
            'potencial': true
          },
          'id_precision_coordenada': {
            'id': null,
            'tipo_precision': ''
          },
          'codigo': null,
          'nombre': '',
          'provincia': '',
          'municipio': '',
          'poblacion': null,
          'direccion': null,
          'high_press_main_in_service_dis': '',
          'in_service_mains_distance': '',
          'fecha_cambio_status': null,
          'fecha_presupuesto_entregado': null,
          'motivo_rechazo': null,
          'motivo_no_potencial': null,
          'observaciones': null,
          'geom': '',
          'resto_direccion': null,
          'direccion_no_estructurada': '',
          'visible': true,
          'codigo_via': null,
          'tipo_via': null,
          'nombre_via': null,
          'codigo_postal': '',
          'google_place_id': null,
          'empresa_instaladora': null,
          'datos_contacto': '',
          'codigo_cnae': null,
          'id_amp_origen': null,
          'metadatos': '',
          'longitud_original': null,
          'latitud_original': null,
          'epsg_original': null,
          'create_user': '',
          'create_date': '',
          'update_user': '',
          'update_date': '',
          'cliente': false,
          'numero': null,
          'anexo': null,
          'codigo_provincia_zeus': '',
          'codigo_municipio_zeus': '',
          'codigo_poblacion_zeus': null,
          'intocable': '',
          'not_abandoned_mains_distance': '',
          'high_pressure_mains_distance': '',
          'nombre_propietario': null,
          'email_propietario': null,
          'telefono_propietario': null
        },
        'tipo_name': '',
        'desc': ''
      }
    };
  },
  created () {

  },
  mounted: function () {
    if (this.logged) {
      this.getPermisos();
      this.$http.get('categorias_gn_comercial/', {params: {not_paginated: true}}).then(result => {
        this.ComercialTypes = result.data;
      });
    } else {
      this.loading = false;
    }
  }
};
</script>

<!-- third party css -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="font-awesome/css/font-awesome.min.css"></style>
<!--Kernel css -->
<style lang="scss">
@import 'assets/styles/base.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue